import { goalsService } from "@/_services/goals.service"

export default {
  namespaced: true, 

  state: {
    activeGoal: null,
    completedGoalList: null,
    unActiveGoalList: null, 
    goalList: null,
    selectedGoal: null,
    responseCreateGoal: null
  },

  mutations: {
    setGoalList(state, goalList){
      state.goalList = goalList
      state.activeGoal = goalList.find(el => el.active == "true")
      state.completedGoalList = goalList.filter(el => el.status == "completed")
      state.unActiveGoalList = goalList.filter(el => el.active == "false" && el.status == "in progress")
    },

    setSelectedGoal(state, payload) {
      state.selectedGoal = payload
    },

    setResponseCreateGoal(state, payload) {
      state.responseCreateGoal = payload
    }
  },
  
  actions: {
    loadGoalList({ commit }) {
      return goalsService.getAllGoals().then(data => {
        commit('setGoalList', data.goals)
      })
    },

    getFormGoal({ commit }) {
      return goalsService.createFormGoals().then(data => {
        commit('setSelectedGoal', data.goals)
      })
    },

    addGoal({ commit, dispatch }, obj) {
      return goalsService.createGoals(obj).then(data => {
        commit('setResponseCreateGoal', data)
        dispatch('loadGoalList')
      })
    },

    sendNewAttachment({ dispatch }, obj) {
      return goalsService.setAttachmentOne(obj).then(() => {
        dispatch('afterAttachment', {goalsInfo: obj, state: 0})
      })
    },

    afterAttachment({ commit }, obj) {
      commit
      return goalsService.afterAttachment(obj.goalsInfo, obj.state)
    },

    deleteSpeech({ commit }, obj) {
      commit  
      return goalsService.delSpeech(obj, obj.state)
    },

    sendNewSpeech({ dispatch }, obj) {
      return goalsService.setSpeech(obj).then(() => {
        dispatch('afterSpeech', {goalsInfo: obj, state: 0})
      })
    },

    afterSpeech({ commit }, obj) {
      commit
      return goalsService.afterSpeech(obj.goalsInfo, obj.state)
    },

    deleteAttachment({ commit }, obj) {
      commit  
      return goalsService.delAttachment(obj, obj.state)
    },

    changeActive({ dispatch }, obj) {
      return goalsService.changeActiveGoal(obj).then(() => {
        dispatch('loadGoalList')
      })
    },

    loadGoalPhoto({ commit }, goalUuid) {
      commit
      return goalsService.getLoadedPhoto(goalUuid).then(data => {
        return data
      })
    },

    loadGoalSpeech({ commit }, goalUuid) {
      commit
      return goalsService.getLoadedSpeech(goalUuid).then(data => {
        return data
      })
    }
  
  }
  
}